import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "@/layouts/DashboardLayout";
import Overview from "@/pages/Overview";
import Costs from "@/pages/Costs";
import CarrierPerformance from "@/pages/CarrierPerformance";
import Reports from "@/pages/Reports";
import AiAssistant from "@/pages/AiAssistant";
import { Toaster } from "@/components/ui/sonner";
import { FilterProvider } from "@/state/FilterContext";

function App() {
  return (
    <div className="App">
      <FilterProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<DashboardLayout />}>
              <Route path="/" element={<Overview />} />
              <Route path="/maliyetler" element={<Costs />} />
              <Route path="/nakliyeci-performansi" element={<CarrierPerformance />} />
              <Route path="/raporlar" element={<Reports />} />
              <Route path="/ai-asistan" element={<AiAssistant />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </FilterProvider>
    </div>
  );
}

export default App;
